import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from "styled-components";
import { borders, color, lineHeight } from "styled-system";
import Box from "../Box";
import { useThemeDefaults, pipe, transform, textDecoration } from "../utils";
import { focusVisibleStyle, hoverFocus } from "../focus"; // set the hover colors

var hoverColor = pipe(function (props) {
  return {
    color: props.hoverColor,
    theme: props.theme
  };
}, color, hoverFocus);
var hoverBg = pipe(function (props) {
  return {
    bg: props.hoverBg,
    theme: props.theme
  };
}, color, hoverFocus);
var hoverTransform = pipe(function (props) {
  return {
    transform: props.hoverTransform,
    theme: props.theme
  };
}, transform, hoverFocus);
var hoverBorder = pipe(function (props) {
  return {
    border: props.hoverBorder,
    borderColor: props.hoverBorderColor,
    theme: props.theme
  };
}, borders, hoverFocus);
var hoverTextDecoration = pipe(function (props) {
  return {
    textDecoration: props.hoverTextDecoration,
    theme: props.theme
  };
}, textDecoration, hoverFocus);
var Link = useThemeDefaults(function (props) {
  return {
    color: props.theme.colors.ctrl,
    cursor: "pointer",
    as: "a",
    hoverTextDecoration: "underline"
  };
}, styled(Box).withConfig({
  displayName: "Link",
  componentId: "sc-1tc8rtf-0"
})(hoverTextDecoration, focusVisibleStyle, hoverColor, hoverBg, hoverTransform, hoverBorder, lineHeight));
Link.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Box.propTypes), focusVisibleStyle.propTypes), lineHeight.propTypes), {}, {
  hoverColor: color.propTypes.color
});
export default Link;